/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Big Menu functionality
// Make variables globally accessible for inline scripts
window.menuFirstFocusableElement = null;
window.menuLastFocusableElement = null;

// Make functions globally accessible
window.getFocusableElements = function getFocusableElements(container) {
    if (!container) return { first: null, last: null, all: [] };

    const elements = container.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
    const focusableElements = Array.from(elements).filter(element => {
        const style = window.getComputedStyle(element);
        return style.display !== 'none' &&
               style.visibility !== 'hidden' &&
               style.opacity !== '0' &&
               element.offsetWidth > 0 &&
               element.offsetHeight > 0 &&
               !element.disabled;
    });

    return {
        first: focusableElements[0] || null,
        last: focusableElements[focusableElements.length - 1] || null,
        all: focusableElements
    };
};

function megaMenuInit() {
    // Remove menu open class first, outside the loop
    document.body.classList.remove('ch-menu-open');

    document.querySelectorAll('.ch-big-menu').forEach(menuBlock => {
        const menuContainer = menuBlock.querySelector('.ch-big-menu__container');
      const submenuModal = menuContainer ? menuContainer.querySelector('.ch-big-menu__modal') : null;
        const titleButton = menuBlock.querySelector('.ch-big-menu__title');
        const closeButton = menuBlock.querySelector('.ch-big-menu__close-button');
        const backButton = menuBlock.querySelector('.ch-big-menu__back-button');

        if (!menuContainer || !titleButton || !closeButton || !backButton) {
            console.warn('megaMenuInit: Missing required elements', {
                menuContainer: !!menuContainer,
                titleButton: !!titleButton,
                closeButton: !!closeButton,
                backButton: !!backButton
            });
            return;
        }

        // Skip if already initialized
        if (titleButton._megaMenuInitialized) {
            return;
        }

        // Mark as initialized
        titleButton._megaMenuInitialized = true;
        closeButton._megaMenuInitialized = true;
        backButton._megaMenuInitialized = true;
        setMenuA11yState(titleButton, submenuModal, false);

        titleButton.addEventListener('click', () => {
            document.body.classList.add('ch-menu-open');
            menuBlock.classList.add('ch-modal-active');
            menuContainer.classList.add('modal-style-open');
          setMenuA11yState(titleButton, submenuModal, true);

          const focusableElements = window.getFocusableElements(submenuModal);
            window.menuFirstFocusableElement = focusableElements.first;
            if (window.menuFirstFocusableElement) window.menuFirstFocusableElement.focus();
            window.menuLastFocusableElement = focusableElements.last;
        });

        closeButton.addEventListener('click', () => {
            document.body.classList.remove('ch-menu-open');
            menuBlock.classList.remove('ch-modal-active');
            menuContainer.classList.remove('modal-style-open');
          setMenuA11yState(titleButton, submenuModal, false);
            window.menuFirstFocusableElement = null;
            window.menuLastFocusableElement = null;
          titleButton.focus();

            // Reset main header hamburger icon state
            const mainHeaderButton = document.querySelector('[data-action="open-custom-menu"]');
            if (mainHeaderButton) {
                const iconState = mainHeaderButton.closest('.icon-state');
                if (iconState) {
                    iconState.setAttribute('aria-expanded', 'false');
                }
            }

            // Reset custom header menu state
            const customHeaderSection = document.querySelector('.custom-header-section');
            if (customHeaderSection) {
                customHeaderSection.classList.remove('header-menu-open');
            }
        });

        backButton.addEventListener('click', () => {
            menuBlock.classList.remove('ch-modal-active');
            menuContainer.classList.remove('modal-style-open');
          setMenuA11yState(titleButton, submenuModal, false);
          titleButton.focus();

            // Try to find focusable elements in either header-blocks or nav-bar
            const headerContainer = document.querySelector('.header-blocks') || document.querySelector('.nav-bar');
            if (headerContainer) {
                const focusableElements = window.getFocusableElements(headerContainer);
                window.menuFirstFocusableElement = focusableElements.first;
                window.menuLastFocusableElement = focusableElements.last;
            }

            // Check if all modals are closed, if so reset everything
            const anyModalActive = document.querySelector('.ch-modal-active');
            if (!anyModalActive) {
                document.body.classList.remove('ch-menu-open');

                // Reset main header hamburger icon state
                const mainHeaderButton = document.querySelector('[data-action="open-custom-menu"]');
                if (mainHeaderButton) {
                    const iconState = mainHeaderButton.closest('.icon-state');
                    if (iconState) {
                        iconState.setAttribute('aria-expanded', 'false');
                    }
                }

                // Reset custom header menu state
                const customHeaderSection = document.querySelector('.custom-header-section');
                if (customHeaderSection) {
                    customHeaderSection.classList.remove('header-menu-open');
                }
            }
        });
    });
}

  function setMenuA11yState(triggerButton, submenuModal, isOpen) {
    if (triggerButton) {
      triggerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (submenuModal) {
      submenuModal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }
  }

// Initialize on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', megaMenuInit);
} else {
    megaMenuInit();
}

// Re-initialize after Shopify section rendering (for theme editor)
document.addEventListener('shopify:section:load', megaMenuInit);

document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && window.menuFirstFocusableElement && window.menuLastFocusableElement) {
        if (event.shiftKey) {
            if (document.activeElement === window.menuFirstFocusableElement) {
                event.preventDefault();
                window.menuLastFocusableElement.focus();
            }
        } else {
            if (document.activeElement === window.menuLastFocusableElement) {
                event.preventDefault();
                window.menuFirstFocusableElement.focus();
            }
        }
    }
});

document.addEventListener(
  "click",
  function (event) {
    if (event.target.id !== "togglePassword") return;

    var passwordField = document.querySelector('input[id*="login-customer[password]"]');

    if (!passwordField) return;

    if (event.target.innerText === "Show") {
      event.target.innerText = "Hide";
      passwordField.type = "text";
    } else {
      event.target.innerText = "Show";
      passwordField.type = "password";
    }
  },
  false
);

/* Video Widget */
function once(fn, context) {
  var result;
  return function() {
      if (fn) {
          result = fn.apply(context || this, arguments);
          fn = null;
      }
      return result;
  };
}

function moveToEnd(move, to) {
  move.appendChild(to);
}

const videoWidget = document.querySelector('#videoWidget');
const prVideoContainer = document.querySelector('#video-widget-container');
const footer = document.querySelector('footer');
const body = document.querySelector('body');


function prVideoWidget(id, url, placeholder, prodUrl, prodImg, prodTitle) {

  const productUrl = prodUrl;
  const productImg = prodImg;
  const productTitle = prodTitle;

  const closeBtn = document.querySelector('#close');

  const move_once = once(moveToEnd(body, videoWidget));
  const videoElement = document.createElement('video');
        videoElement.src = url;
        videoElement.alt = "Lazy loaded video";
        videoElement.poster = placeholder;
        videoElement.controls = true;
        videoElement.preload = 'none';
        videoElement.id = 'prVideoWidget-'+id;
  const prVideoObserver = new IntersectionObserver(function (entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting) {

        prVideoContainer.appendChild(videoElement);

        videoElement.load();

        prVideoObserver.unobserve(prVideoContainer);
      }
    });
  }, {threshold: 1});

  move_once();

  prVideoObserver.observe(prVideoContainer);

  var ctaVideoWidget = function ctaVideoWidget(img, title){
      return '<div class="video-widget__inner-cta"><div class="video-widget__inner-cta--product"><img src="'+ img +'" alt="'+ title +'" wdith="50"><h5 class="video-widget__inner-title">'+ productTitle +'</h5></div><div class="video-widget__inner-cta--btn"><a href="'+ productUrl +'" role="button" class="button button--primary button--full">Shop Now</a></div></div>';
  }
  if (productUrl != null && productImg != null && productTitle != null) {
    document.querySelector('.video-widget__inner').insertAdjacentHTML("beforeend", ctaVideoWidget(productImg, productTitle));
  }


  closeBtn.addEventListener('click', function(e){
    e.preventDefault();
    hideVideoWidget(videoWidget, prVideoContainer);
  });

}

const videoWidgetLaunchBtns = document.querySelectorAll('.video-widget-launch-btn');
for (var i = 0; i < videoWidgetLaunchBtns.length; i++) {
  videoWidgetLaunchBtns[i].addEventListener('click', function(event) {
    event.preventDefault();
    console.log('clicked');
      var videoID = event.target.closest('button').dataset.video;
      var videoUrl = event.target.closest('button').dataset.videourl;
      var videoPlaceholder = event.target.closest('button').dataset.videoplaceholder;
      var productUrl = event.target.closest('button').dataset.producturl;
      var productImg = event.target.closest('button').dataset.productimg;
      var productTitle = event.target.closest('button').dataset.producttitle;
      var aspectRatio = event.target.closest('button').dataset.aspectratio;
      var ratio = aspectRatio ? aspectRatio : 'vertical';

      prVideoWidget(videoID, videoUrl, videoPlaceholder, productUrl, productImg, productTitle);

      document.body.classList.add('hide-chat');
      document.body.classList.add('overlay');
      videoWidget.classList.toggle('hide');
      videoWidget.classList.add(ratio);
      videoWidget.setAttribute('aria-hidden', 'false');

  }, false);
}

function hideVideoWidget(widget, container) {

  var aspectRatio = widget.classList.contains('vertical');
  widget.classList.add('hide');
  container.innerHTML = '';
  aspectRatio ? widget.classList.remove('vertical') : widget.classList.remove('square');
  document.body.classList.remove('hide-chat');
  document.body.classList.remove('overlay');
  var removeCTA = document.querySelector('.video-widget__inner-cta');
  if (removeCTA) {
    removeCTA.parentNode.removeChild(removeCTA);
  }
  widget.setAttribute('aria-hidden', 'true');
}

document.addEventListener('click', function(event){
  if(!event.target.matches('.overlay.hide-chat')) return;
  hideVideoWidget(videoWidget, prVideoContainer);
}, false);

function initRivoPoints() {
  const rivoPoints = document.querySelectorAll('.js-rivo-card-alt-trigger');
  if (rivoPoints.length > 0) {
    rivoPoints.forEach(function(card) {
      var groupLoyaltyInput = card.querySelector('input[name="loyalty-value"]');
      if (groupLoyaltyInput) {
              var points = updatePotentialPoints(groupLoyaltyInput.value);
        if (!isNaN(points) || !isFinite(points) || points === 0) {
          var pointsSpan =  card.querySelector('#rivo-points-value');
          if (pointsSpan) pointsSpan.textContent = points;
          card.style.display = '';
        }
      }
    });
  }
}
function getUSDValue(localValue) {
  if (window.Shopify && window.Shopify.currency) {
    var rate = window.Shopify.currency.rate;
    var normalized = localValue.replace(',', '.').replace(/[^0-9.]/g, '');
    var numericValue = Number(normalized);
    return numericValue / rate;
  }
  return Number(localValue.replace(',', '.').replace(/[^0-9.]/g, ''));
}

function updatePotentialPoints(dataValue) {
  var balanceAmount = Number(document.querySelector('.rivo-container-points').getAttribute('data-balance-amount')) || 1;
  var usdValue = getUSDValue(dataValue);
  var roundedValue = Math.ceil(usdValue);
  var points = roundedValue * balanceAmount;
  return points;
}
window.addEventListener('load', initRivoPoints);

/* Country Selector Custom Dropdown */
(function() {
  // Initialize all custom selects
  function initCustomSelects() {
    const customSelects = document.querySelectorAll('[data-custom-select]');

    customSelects.forEach(function(selectWrapper) {
      const trigger = selectWrapper.querySelector('[data-custom-select-trigger]');
      const dropdown = selectWrapper.querySelector('[data-custom-select-dropdown]');
      const searchInput = selectWrapper.querySelector('[data-custom-select-search]');
      const options = selectWrapper.querySelectorAll('.custom-select__option');
      const hiddenSelect = selectWrapper.querySelector('.custom-select__hidden');
      const scrollBtn = dropdown ? dropdown.querySelector('[data-scroll-down]') : null;

      if (!trigger || !dropdown || !hiddenSelect) return;

      // Helper function to manage focusable elements
      function setDropdownFocusable(dropdown, isFocusable) {
        const inputs = dropdown.querySelectorAll('input');
        const buttons = dropdown.querySelectorAll('button');

        inputs.forEach(function(el) {
          if (isFocusable) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });

        buttons.forEach(function(el) {
          if (isFocusable) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });

        // Options should always be tabindex -1, navegables con flechas
        const listOptions = dropdown.querySelectorAll('[role="option"]');
        listOptions.forEach(function(el) {
          el.setAttribute('tabindex', '-1');
        });
      }

      // Initialize dropdown as non-focusable
      setDropdownFocusable(dropdown, false);

      // Track current focused option
      var currentFocusIndex = -1;

      // Keyboard navigation for options
      function handleKeyboardNavigation(e, visibleOptions) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          currentFocusIndex = Math.min(currentFocusIndex + 1, visibleOptions.length - 1);
          visibleOptions[currentFocusIndex].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          currentFocusIndex = Math.max(currentFocusIndex - 1, 0);
          visibleOptions[currentFocusIndex].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (currentFocusIndex >= 0 && currentFocusIndex < visibleOptions.length) {
            visibleOptions[currentFocusIndex].click();
          }
        } else if (e.key === 'Escape') {
          dropdown.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-expanded', 'false');
          setDropdownFocusable(dropdown, false);
          trigger.focus();
          currentFocusIndex = -1;
        }
      }

      // Toggle dropdown
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const isHidden = dropdown.getAttribute('aria-hidden') === 'true';

        // Close all other dropdowns
        document.querySelectorAll('[data-custom-select-dropdown]').forEach(function(dd) {
          if (dd !== dropdown) {
            dd.setAttribute('aria-hidden', 'true');
            setDropdownFocusable(dd, false);
            // Update aria-expanded for other triggers
            var otherTrigger = dd.parentElement.querySelector('[data-custom-select-trigger]');
            if (otherTrigger) {
              otherTrigger.setAttribute('aria-expanded', 'false');
            }
          }
        });

        dropdown.setAttribute('aria-hidden', !isHidden);
        trigger.setAttribute('aria-expanded', isHidden);
        setDropdownFocusable(dropdown, isHidden);

        if (isHidden) {
          currentFocusIndex = -1;
          if (searchInput) {
            searchInput.focus();
          } else {
            // If no search, focus selected option or first visible option
            var visibleOptions = Array.from(options).filter(function(opt) {
              return opt.style.display !== 'none';
            });

            // Try to find the selected option
            var selectedOption = visibleOptions.find(function(opt) {
              return opt.classList.contains('is-selected');
            });

            if (selectedOption) {
              // Focus the selected option
              currentFocusIndex = visibleOptions.indexOf(selectedOption);
              selectedOption.focus();
            } else if (visibleOptions.length > 0) {
              // Fallback to first option if no selection
              currentFocusIndex = 0;
              visibleOptions[0].focus();
            }
          }
        }
      });

      // Search functionality (only if search input exists)
      if (searchInput) {
        searchInput.addEventListener('input', function() {
          const searchTerm = this.value.toLowerCase();

          options.forEach(function(option) {
            const text = option.querySelector('.custom-select__text').textContent.toLowerCase();
            if (text.includes(searchTerm)) {
              option.style.display = '';
            } else {
              option.style.display = 'none';
            }
          });

          currentFocusIndex = -1;
        });

        // Keyboard navigation from search input
        searchInput.addEventListener('keydown', function(e) {
          var visibleOptions = Array.from(options).filter(function(opt) {
            return opt.style.display !== 'none';
          });

          if (e.key === 'ArrowDown' && visibleOptions.length > 0) {
            e.preventDefault();
            currentFocusIndex = 0;
            visibleOptions[0].focus();
          } else if (e.key === 'Escape') {
            dropdown.setAttribute('aria-hidden', 'true');
            trigger.setAttribute('aria-expanded', 'false');
            setDropdownFocusable(dropdown, false);
            trigger.focus();
            currentFocusIndex = -1;
          }
        });
      }

      // Select option
      options.forEach(function(option, index) {
        // Make options focusable
        option.setAttribute('tabindex', '-1');

        // Click handler
        option.addEventListener('click', function() {
          const value = this.getAttribute('data-value');
          const text = this.querySelector('.custom-select__text').textContent;
          const flag = this.querySelector('.custom-select__flag');

          // Update hidden select
          hiddenSelect.value = value;

          // Update trigger display
          const triggerValue = trigger.querySelector('.custom-select__value');

          // Update flag if exists
          if (flag) {
            const flagClone = flag.cloneNode(true);
            const triggerFlag = triggerValue.querySelector('.custom-select__flag');
            if (triggerFlag) {
              triggerFlag.replaceWith(flagClone);
            }
          }

          triggerValue.querySelector('.custom-select__text').textContent = text;

          // Update selected state
          options.forEach(function(opt) {
            opt.classList.remove('is-selected');
            opt.setAttribute('aria-selected', 'false');
          });
          this.classList.add('is-selected');
          this.setAttribute('aria-selected', 'true');

          // Close dropdown
          dropdown.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-expanded', 'false');
          setDropdownFocusable(dropdown, false);
          trigger.focus();
          currentFocusIndex = -1;

          // Reset search if exists
          if (searchInput) {
            searchInput.value = '';
          }
          options.forEach(function(opt) {
            opt.style.display = '';
          });
        });

        // Keyboard navigation on options
        option.addEventListener('keydown', function(e) {
          var visibleOptions = Array.from(options).filter(function(opt) {
            return opt.style.display !== 'none';
          });

          currentFocusIndex = visibleOptions.indexOf(this);
          handleKeyboardNavigation(e, visibleOptions);
        });
      });

      // Scroll down button functionality
      if (scrollBtn) {
        scrollBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const list = dropdown.querySelector('.custom-select__list');

          if (list) {
            // Scroll down by 100px
            list.scrollBy({
              top: 100,
              behavior: 'smooth'
            });
          }
        });
      }

      // Close dropdown when focus leaves
      selectWrapper.addEventListener('focusout', function(e) {
        // Use setTimeout to allow the browser to update activeElement
        setTimeout(function() {
          // Check if the new focused element is outside this select wrapper
          if (!selectWrapper.contains(document.activeElement)) {
            dropdown.setAttribute('aria-hidden', 'true');
            trigger.setAttribute('aria-expanded', 'false');
            setDropdownFocusable(dropdown, false);
            currentFocusIndex = -1;

            // Reset search if exists
            if (searchInput) {
              searchInput.value = '';
            }
            options.forEach(function(opt) {
              opt.style.display = '';
            });
          }
        }, 0);
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-custom-select]')) {
        document.querySelectorAll('[data-custom-select-dropdown]').forEach(function(dropdown) {
          dropdown.setAttribute('aria-hidden', 'true');

          // Update aria-expanded on trigger
          var trigger = dropdown.parentElement.querySelector('[data-custom-select-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
          }

          // Remove focus from dropdown elements
          const focusableElements = dropdown.querySelectorAll('input, button, [role="option"]');
          focusableElements.forEach(function(el) {
            el.setAttribute('tabindex', '-1');
          });
        });
      }
    });
  }

  // Close popover when clicking cancel button
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-action="close-popover"]')) {
      const popover = e.target.closest('.popover--country-selector');
      if (popover) {
        popover.setAttribute('aria-hidden', 'true');
        const trigger = document.querySelector('[aria-controls="country-selector-popover"]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }

        // Remove backdrop if exists
        const backdrop = document.querySelector('.popover-backdrop');
        if (backdrop) {
          backdrop.classList.remove('is-visible');
          setTimeout(function() {
            if (backdrop.parentNode) {
              backdrop.parentNode.removeChild(backdrop);
            }
          }, 300);
        }
      }
    }
  });

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomSelects);
  } else {
    initCustomSelects();
  }
})();

// CANCEL ORDER
function cancelOrder(orderId) {
    const reason = document.getElementById(orderId + '-reason').value;
    const spinners = document.getElementsByClassName(orderId + '-spinner');
    const proceedBtn = document.getElementById(orderId + '-proceed');
    const cancelBtn = document.getElementById(orderId + '-cancel');
    const proceedLabels = document.getElementsByClassName(orderId + '-text');

    proceedBtn.disabled = true
    cancelBtn.disabled = true

    Array.from(spinners).forEach((spinner) => {
      spinner.style.display = 'inline-flex';
    });

    Array.from(proceedLabels).forEach((proceedLabel) => {
      proceedLabel.style.display = 'none'
    });

    fetch("/a/cancel/customer-cancel-order", {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                "store": 'shop_us_vf',
                "action": 'cancelOrder',
                "orderId": orderId,
                "reason": reason
            })
        })
        .then(function(response) {
           if (!response.ok) {
                return response.text().then(data => {
                    if (response.status === 500) {
                        throw new Error('internal_server_error');
                    }
                    throw new Error(data || 'An unexpected error occurred.');
                });
            }
            return response.text();
        })
        .then(function(data) {
            window.location.href = '?success=true';
        })
        .catch(function(error) {
          if (error == "Error: no_longer_possible_cancel") {
            window.location.href = '?error=no_longer_possible_cancel';
          } else {
              window.location.href = '?error=internal_server_error';
          }
         });
}

function showToast(message, type) {
    let toastContainer = document.getElementById('toast-container');

    if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.id = 'toast-container';
        document.body.appendChild(toastContainer);
    }

    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;

    if (type === 'success') {
      toast.style.backgroundColor = '#2ecc71';
      toastContainer.setAttribute('role', 'status');
      toastContainer.setAttribute('aria-live', 'polite');
      toastContainer.setAttribute('aria-atomic', 'true');
    } else if (type === 'error') {
      toast.style.backgroundColor = '#e74c3c';
      toastContainer.setAttribute('role', 'alert');
      toastContainer.setAttribute('aria-live', 'assertive');
      toastContainer.setAttribute('aria-atomic', 'true');
    }

    toastContainer.appendChild(toast);

    setTimeout(() => {
        toast.style.opacity = '1';
    }, 10);

    setTimeout(() => {
        toast.style.opacity = '0';
        setTimeout(() => {
            toastContainer.removeChild(toast);
        }, 300);
    }, 4000);
}